import { Grid, Paper, Dialog, DialogContent, DialogTitle, Button, DialogActions, Switch, Chip, Table, TableBody, TableCell, TableHead, TableRow, Avatar, Pagination } from '@mui/material'
import { styled } from '@mui/system'
import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate, NavLink } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import apiFunctions from '../../api/apiFunctions';
import Toptag from '../../components/toptag/Toptag'
import EventTagSelect from '../../components/events/EventTagSelect'
import { mergeEventTagOptions } from '../../components/events/mergeEventTagOptions'
import LocationDetailsCard from '../../components/events/LocationDetailsCard'
import { useGooglePlaceMap } from '../../hooks/useGooglePlaceMap'
import { hasValidCoords, resolveTimezone } from '../../utils/eventTimezone'
import './eventDetail.css'
import '../../components/events/eventForm.css'
import Loader from '../../components/Loader/Loader'



const BackPaper = styled(Paper)({
    minHeight: "calc(100vh - 130px)",
    borderRadius: "0",
    padding: "20px",
    overflow: "visible",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const EventDetail = ({ objs }) => {

    const location = useLocation();
    // console.log(location, "location---------------------")
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true); // show loader until the event detail resolves
    const [edit, setEdit] = useState(false)
    const [err, setErr] = useState(false)
    const [obj, setObj] = useState({})
    const mapRef = useRef(null);
    const inputRef = useRef(null);
    const [mapCenter, setMapCenter] = useState(null)
    const [eventTimezone, setEventTimezone] = useState('')
    const [eventTag, setEventTag] = useState([])
    const [attendanceStats, setAttendanceStats] = useState(null)
    const [showAttendanceDetails, setShowAttendanceDetails] = useState(false)
    const [activeUsersPage, setActiveUsersPage] = useState(1)
    const [attendedUsersPage, setAttendedUsersPage] = useState(1)
    const [usersPerPage, setUsersPerPage] = useState(10)
    // console.log(updatedObject, "name at a time when gettin userprofilew----------------")

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const onPlaceSelected = useCallback((data) => {
        const tzResult = resolveTimezone(data.latitude, data.longitude)
        setEventTimezone(tzResult.ok ? tzResult.timezone : '')
        setObj((prev) => ({
            ...prev,
            place: data.place,
            latitude: data.latitude,
            longitude: data.longitude,
            map_url: data.map_url,
            country: data.country,
            country_code: data.country_code,
            state: data.state,
            state_code: data.state_code,
        }))
        setErr(false)
    }, [])

    const { confirmedPlace, setConfirmedPlace } = useGooglePlaceMap({
        mapRef,
        inputRef,
        onPlaceSelected,
        initialCenter: mapCenter || (location.state
            ? { lat: location.state.lat, lng: location.state.lng }
            : undefined),
        enabled: !isLoading,
        activeKey: edit,
    })

    const handlecChange = () => {
        setConfirmedPlace(obj.place || '')
        setEdit(true)
    }

    const addata = (e) => {
        setErr(false)
        const { name, value } = e.target;
        if (name === 'world_rank' || name === 'required_people' || name === 'live_expected_people' || name === 'sector_rank') {
            setObj({
                ...obj,
                [name]: parseInt(value),
            });
        } else {
            setObj({
                ...obj,
                [e.target.name]: e.target.value,
            });
        }

    }


    const getEventDetail = async (previous) => {
        try {
        const result = await apiFunctions.eventDetail(location.state.id);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            setIsLoading(false)   // was missing -> loader stuck forever on error

        } else {
            const eventData = result.data.data;
            // NOTE: Normalize tag to array format for backward compatibility
            // Extract tag IDs from tag array or tagDetail array
            if (eventData.tagDetail && Array.isArray(eventData.tagDetail) && eventData.tagDetail.length > 0) {
                // NOTE: Use tagDetail if available (populated tags)
                eventData.tag = eventData.tagDetail.map(t => t._id || t).filter(Boolean);
            } else if (eventData.tag && !Array.isArray(eventData.tag)) {
                eventData.tag = eventData.tag ? [eventData.tag] : [];
            } else if (!eventData.tag) {
                eventData.tag = [];
            }
            // NOTE: Normalize tagDetail to array format
            if (eventData.tagDetail && !Array.isArray(eventData.tagDetail)) {
                eventData.tagDetail = eventData.tagDetail ? [eventData.tagDetail] : [];
            } else if (!eventData.tagDetail) {
                eventData.tagDetail = [];
            }
            if (eventData.location?.coordinates?.length >= 2) {
                eventData.longitude = eventData.longitude ?? eventData.location.coordinates[0];
                eventData.latitude = eventData.latitude ?? eventData.location.coordinates[1];
            }
            if (hasValidCoords(eventData.latitude, eventData.longitude)) {
                setMapCenter({ lat: Number(eventData.latitude), lng: Number(eventData.longitude) });
                const tzResult = resolveTimezone(eventData.latitude, eventData.longitude);
                setEventTimezone(tzResult.ok ? tzResult.timezone : '');
            }
            setConfirmedPlace(eventData.place || '');
            setObj(eventData)
            await delay(1000);
            setIsLoading(false)

        }
        } catch (e) {
            toast.error('Unable to load event details', { position: toast.POSITION.TOP_RIGHT });
            setIsLoading(false)   // network/500 error -> clear the loader instead of hanging
        }
    }
    // console.log(obj, "objetttttttttttttttttttttttttttttttttttttttttttt+++++++++++")

    const updateEventDetail = async (event) => {
        const id = location.state.id;
        event.preventDefault();

        const tagsArray = Array.isArray(obj.tag) ? obj.tag : (obj.tag ? [obj.tag] : []);
        const isInvalid = (
            obj.title === ''
            || obj.place === ''
            || !obj.country_code
            || obj.annual_emission_of_co2 === ''
            || tagsArray.length === 0
            || obj.event_status === ''
            || obj.sector_of_pollution === ''
            || obj.source_id === ''
            || obj.event_type === ''
            || obj.place !== confirmedPlace
            || !hasValidCoords(obj.latitude, obj.longitude)
        );

        if (isInvalid) {
            setErr(true);
            return;
        }

        setErr(false);
        const eventObj = {
            title: obj.title,
            place: obj.place,
            latitude: obj.latitude,
            longitude: obj.longitude,
            map_url: obj.map_url,
            country: obj.country,
            country_code: obj.country_code,
            state_code: obj.state_code || '',
            world_rank: obj.world_rank,
            required_people: obj.required_people,
            annual_emission_of_co2: obj.annual_emission_of_co2,
            sector_of_pollution: obj.sector_of_pollution,
            source_id: obj.source_id,
            sector_rank: obj.sector_rank,
            event_type: obj.event_type,
            tag: tagsArray,
            event_status: obj.event_status,
            special_notes: obj.special_notes,
        };

        const result = await apiFunctions.updateEvent(id, eventObj);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        } else {
            setIsLoading(false)
            setEdit(false)
            toast.success(result.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        }
    }

    const updateStatus = async (event) => {
        const id = location.state.id;
        event.preventDefault();
        const result = await apiFunctions.updateStatus(id, { event_status: event.target.checked ? "Active" : "Inactive" });
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        } else {
            getEventDetail();
            setIsLoading(false)
            setEdit(false)
            toast.success(result.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        }
    }

    const getTags = async () => {
        let limit = 100
        let page = 1
        let search = ''
        let result = await apiFunctions.getAllTag(limit, search, page);
        if (!result.data.status) {
            if (result.data.code === 401) {
                localStorage.clear();
                navigate("/login")
                toast.info("Session Expired Please login again!!")
            }
            toast.error(result.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            setEventTag(result.data.data);
        }
    }
    const event_tag = (id) => {
        let tagArr = eventTag.filter((obj) => obj._id == id);
        return tagArr.length > 0 ? tagArr[0].title : ''
    }
    
    // NOTE: Get tag IDs as array from obj.tag (handles both array and single value for backward compatibility)
    const getTagIds = () => {
        if (!obj.tag) return [];
        if (Array.isArray(obj.tag)) {
            // NOTE: Handle both ObjectId strings and populated objects
            return obj.tag.map(t => {
                if (typeof t === 'string') return t;
                if (t && t._id) return t._id.toString ? t._id.toString() : t._id;
                return null;
            }).filter(Boolean);
        }
        // NOTE: Handle single tag (backward compatibility)
        if (typeof obj.tag === 'string') return [obj.tag];
        if (obj.tag && obj.tag._id) return [obj.tag._id.toString ? obj.tag._id.toString() : obj.tag._id];
        return [];
    }

    const fetchAttendanceStats = async (attendedPage = 1, limit = 10, activePage = null) => {
        if (!location.state?.id) return;
        try {
            const result = await apiFunctions.getEventAttendanceStats(location.state.id, attendedPage, limit, activePage);
            if (result.data.status && result.data.data) {
                setAttendanceStats(result.data.data);
                setAttendedUsersPage(attendedPage);
                if (activePage !== null) {
                    setActiveUsersPage(activePage);
                } else if (result.data.data.currentlyActiveUsers && result.data.data.currentlyActiveUsers.current_page) {
                    setActiveUsersPage(result.data.data.currentlyActiveUsers.current_page);
                }
            }
        } catch (error) {
            console.error('Error fetching attendance stats:', error);
        }
    }

    const handleActiveUsersPageChange = (event, value) => {
        setActiveUsersPage(value);
        fetchAttendanceStats(attendedUsersPage, usersPerPage, value);
    }

    const handleAttendedUsersPageChange = (event, value) => {
        setAttendedUsersPage(value);
        fetchAttendanceStats(value, usersPerPage, activeUsersPage);
    }

    useEffect(() => {
        if (!location.state || !location.state.id) {
            navigate('/home/events');
            return;
        }
        getEventDetail()
        getTags()
        fetchAttendanceStats(1, usersPerPage, 1)
    }, [])


    return (
        <>
            <ToastContainer autoClose={1000} />
            {isLoading ?
                <Loader />
                :
                <>
                    <Toptag />
                    <ToastContainer />
                    <BackPaper>
                        <Grid container direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item style={{ fontSize: "20px", fontWeight: "400", color: "grey" }}>Event Details</Grid>
                            <Grid item>
                                {!edit
                                    ? <button className='newBtn' onClick={handlecChange}>Edit</button>
                                    : <button className='newBtn' onClick={updateEventDetail}>Save</button>}
                            </Grid>
                        </Grid>
                        <hr></hr>

                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} md={6} lg={6} item >
                                <Grid container spacing={3} direction="column" justifyContent="flex-start" alignItems="center">
                                    <Grid item style={{ width: "100%" }}>
                                        <div id='map' ref={mapRef} className="event-form-map" style={{ maxWidth: '440px', marginTop: '8px' }} />
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "8px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "flex-start", maxWidth: "440px" }}>
                                            <div className="popText">Place</div>
                                            {!edit ? (
                                                <input
                                                    type="text"
                                                    className="popInputeventDetail"
                                                    value={obj.place || ''}
                                                    readOnly
                                                    disabled
                                                    style={{ width: '100%' }}
                                                />
                                            ) : null}
                                            <input
                                                type="text"
                                                ref={inputRef}
                                                placeholder="Search event location"
                                                className="popInputeventDetail"
                                                name="place"
                                                id="place"
                                                style={{ display: edit ? 'block' : 'none', width: '100%' }}
                                                value={obj.place || ''}
                                                onChange={(e) => {
                                                    setErr(false);
                                                    setObj((prev) => ({ ...prev, place: e.target.value }));
                                                }}
                                            />
                                            {err && (obj.place === '' || obj.place !== confirmedPlace) ? (
                                                <div className="errText">
                                                    {obj.place === '' ? 'Required!' : 'Please select a valid place from suggestions!'}
                                                </div>
                                            ) : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "8px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start", maxWidth: "440px" }}>
                                            <div className="popText">Location</div>
                                            <LocationDetailsCard location={obj} timezone={eventTimezone} />
                                            {err && !obj.country_code ? (
                                                <div className="errText">Select a place with a valid country from Google Maps.</div>
                                            ) : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Sector Of Pollution</div>
                                            <div><input type="text" className="popInput1" name="sector_of_pollution" id="sector_of_pollution" disabled={!edit ? true : false} value={obj.sector_of_pollution} onChange={addata} /></div>
                                            {err && obj.sector_of_pollution === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Event Status</div>
                                            <div><select className="popInput1" name="event_status" onChange={addata} value={obj.event_status || ''} disabled={!edit ? true : false}>
                                                <option value="Active">Active</option>
                                                <option value="Inactive">Inactive</option>
                                            </select>

                                                {err && obj.tag === '' ? <div className="errText">Required!</div> : null}</div>
                                            {/* {err && obj.sector_of_pollution === '' ? <div className="errText">Required!</div> : null} */}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Sector Rank</div>
                                            <div>
                                                <input type="number" className="popInput1" name="sector_rank" id="sector_rank" disabled={!edit ? true : false} value={obj.sector_rank} onChange={addata} /></div>
                                            {err && obj.sector_rank === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Country's World Rank</div>
                                            <div>
                                                <input type="number" className="popInput1" name="world_rank" id="world_rank" disabled={!edit ? true : false} value={obj.world_rank} onChange={addata} /></div>
                                            {err && obj.world_rank === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Annual Emission Of CO<sub>2</sub></div>
                                            <div>
                                                <input type="text" className="popInput1" name="annual_emission_of_co2" id="annual_emission_of_co2" disabled={!edit ? true : false} value={obj.annual_emission_of_co2} onChange={addata} /></div>
                                            {err && obj.annual_emission_of_co2 === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%", paddingTop: "15px" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Special Notes</div>
                                            <div style={{ width: "100%" }}>
                                                <textarea className="popInput1" name="special_notes" id="special_notes" disabled={!edit ? true : false} value={obj.special_notes} onChange={addata} style={{ minHeight: "90px", resize: "vertical" }} /></div>
                                            {/* {err && obj.special_notes === '' ? <div className="errText">Required!</div> : null} */}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid><Grid xs={12} sm={12} md={6} lg={6} item >
                                <Grid container spacing={2} direction="column" justifyContent="flex-start" alignItems="flex-start" style={{ marginTop: "7px" }}>
                                    <Grid item style={{ width: "100%" }}>

                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Event Title</div>
                                            <div><input type="text" className="popInputeventDetail" name="title" id="title" disabled={!edit ? true : false} value={obj.title} onChange={addata} /></div>
                                            {err && obj.title === '' ? <div className="errText">Required!</div> : null}
                                        </div>

                                    </Grid>
                                    {obj.event_type === "Special" && (
                                    <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Date Of Event</div>
                                            <div>
                                                <NavLink to='/home/events/events-date-and-slots' state={{ id: obj._id }} > <button className='newBtn'>View Event's Dates and Slots</button></NavLink>
                                            </div>
                                            {err && obj.dateTimes?.length === 0 ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    )}
                                    <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Source Id</div>
                                            <div>
                                                <input type="number" className="popInputeventDetail" name="source_id" id="source_id" disabled={!edit ? true : false} value={obj.source_id} onChange={addata} /></div>
                                            {err && obj.source_id === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%" }}>

                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Event Type</div>
                                            <div><input type="text" className="popInputeventDetail" name="event_type" id="event_type" value={obj.event_type} readOnly /></div>
                                            {err && obj.event_type === '' ? <div className="errText">Required!</div> : null}
                                        </div>

                                    </Grid>
                                    <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Live Expected People</div>
                                            <div>
                                                <input type="number" className="popInputeventDetail" name="live_expected_people" id="live_expected_people" disabled={!edit ? true : false} value={obj.live_expected_people} readOnly /></div>
                                            {err && obj.live_expected_people === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Required People</div>
                                            <div>
                                                <input type="number" className="popInputeventDetail" name="required_people" id="required_people" disabled={!edit ? true : false} value={obj.required_people} onChange={addata} /></div>
                                            {err && obj.required_people === '' ? <div className="errText">Required!</div> : null}
                                        </div>
                                    </Grid>
                                    <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Event Tags {!edit && obj.tagDetail && Array.isArray(obj.tagDetail) && obj.tagDetail.length > 0 && `(${obj.tagDetail.length})`}</div>
                                            {!edit ? (
                                                <div>
                                                    {obj.tagDetail && Array.isArray(obj.tagDetail) && obj.tagDetail.length > 0 ? (
                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                                                            {obj.tagDetail.map((tag, index) => (
                                                                <span key={tag._id || index} style={{ 
                                                                    padding: '5px 10px', 
                                                                    backgroundColor: '#f0f0f0', 
                                                                    borderRadius: '4px',
                                                                    fontSize: '12px',
                                                                    display: 'inline-block',
                                                                    marginRight: '5px'
                                                                }}>
                                                                    {tag.title || 'Unknown Tag'}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div style={{ color: '#999', fontStyle: 'italic' }}>No tags selected</div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div style={{ width: '485px', maxWidth: '100%' }}>
                                                    <EventTagSelect
                                                        isMulti
                                                        name="tag"
                                                        hasError={err && (!Array.isArray(obj.tag) || obj.tag.length === 0)}
                                                        options={mergeEventTagOptions(eventTag, obj.tagDetail)}
                                                        value={(() => {
                                                            const selectedIds = getTagIds().map(String);
                                                            if (!selectedIds.length) return [];
                                                            return mergeEventTagOptions(eventTag, obj.tagDetail)
                                                                .filter((opt) => selectedIds.includes(String(opt.value)));
                                                        })()}
                                                        onChange={(selectedOptions) => {
                                                            const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                            setObj({
                                                                ...obj,
                                                                tag: selectedIds,
                                                            });
                                                            setErr(false);
                                                        }}
                                                        placeholder="Select tags..."
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                maxWidth: '100%',
                                                                width: '100%',
                                                                boxSizing: 'border-box',
                                                            }),
                                                            multiValueLabel: (base) => ({
                                                                ...base,
                                                                maxWidth: '150px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }),
                                                            input: (base) => ({
                                                                ...base,
                                                                maxWidth: '100%',
                                                            }),
                                                        }}
                                                    />
                                                    {err && (!Array.isArray(obj.tag) || obj.tag.length === 0) ? <div className="errText">At least one tag is required!</div> : null}
                                                </div>
                                            )}
                                        </div>

                                    </Grid>


                                    {obj.event_type === "Normal" && <Grid item style={{ width: "100%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "10px", alignItems: "flex-start" }}>
                                            <div className="popText">Event Status ({obj.event_status})</div>
                                            <Switch checked={obj.event_status === "Active"} onChange={updateStatus} />
                                        </div>
                                    </Grid>}
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* NOTE: Attendance Statistics Section */}
                        {attendanceStats && (
                            <Grid container spacing={2} style={{ marginTop: '20px', padding: '20px', borderTop: '2px solid #e0e0e0' }}>
                                <Grid item xs={12}>
                                    <div style={{ fontSize: "18px", fontWeight: "600", color: "grey", marginBottom: "15px" }}>
                                        Attendance Statistics
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Paper style={{ padding: '15px', backgroundColor: '#f5f5f5' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <span style={{ fontSize: '16px', fontWeight: '500' }}>Total Attended Users:</span>
                                            <Chip 
                                                label={attendanceStats.totalAttended || 0} 
                                                style={{ backgroundColor: '#4CAF50', color: 'white', fontSize: '16px', padding: '5px 10px' }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontSize: '16px', fontWeight: '500' }}>Currently Active Users:</span>
                                            <Chip 
                                                label={attendanceStats.currentlyActive || 0} 
                                                style={{ backgroundColor: '#2196F3', color: 'white', fontSize: '16px', padding: '5px 10px' }}
                                            />
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => setShowAttendanceDetails(!showAttendanceDetails)}
                                        style={{ marginBottom: '10px' }}
                                    >
                                        {showAttendanceDetails ? 'Hide' : 'Show'} User Details
                                    </Button>
                                </Grid>
                                {showAttendanceDetails && (
                                    <>
                                        {attendanceStats.currentlyActiveUsers && attendanceStats.currentlyActiveUsers.data && attendanceStats.currentlyActiveUsers.data.length > 0 && (
                                            <Grid item xs={12} style={{ marginBottom: '20px' }}>
                                                <div style={{ fontSize: "16px", fontWeight: "500", color: "grey", marginBottom: "10px" }}>
                                                    Currently Active Users ({attendanceStats.currentlyActiveUsers.total || 0})
                                                </div>
                                                <Paper style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>User</TableCell>
                                                                <TableCell>Email</TableCell>
                                                                <TableCell>Slot Time</TableCell>
                                                                <TableCell>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {attendanceStats.currentlyActiveUsers.data.map((user, index) => (
                                                                <TableRow key={index} style={{ backgroundColor: '#e3f2fd' }}>
                                                                    <TableCell>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                            <Avatar src={user.profile_photo} style={{ width: '30px', height: '30px' }} />
                                                                            {user.username || 'N/A'}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>{user.email}</TableCell>
                                                                    <TableCell>
                                                                        {user.slotStartTime} - {user.slotEndTime}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <Chip 
                                                                            label="Currently Active" 
                                                                            size="small"
                                                                            style={{ backgroundColor: '#4CAF50', color: 'white' }}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Paper>
                                                {attendanceStats.currentlyActiveUsers.total_pages > 1 && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                                        <Pagination 
                                                            count={attendanceStats.currentlyActiveUsers.total_pages} 
                                                            page={attendanceStats.currentlyActiveUsers.current_page || activeUsersPage}
                                                            onChange={handleActiveUsersPageChange}
                                                            color="primary"
                                                        />
                                                    </div>
                                                )}
                                            </Grid>
                                        )}
                                        {attendanceStats.attendedUsers && attendanceStats.attendedUsers.data && attendanceStats.attendedUsers.data.length > 0 && (
                                            <Grid item xs={12}>
                                                <div style={{ fontSize: "16px", fontWeight: "500", color: "grey", marginBottom: "10px" }}>
                                                    All Attended Users ({attendanceStats.attendedUsers.total || 0})
                                                </div>
                                                <Paper style={{ maxHeight: '400px', overflow: 'auto' }}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>User</TableCell>
                                                                <TableCell>Email</TableCell>
                                                                <TableCell>Last Attended</TableCell>
                                                                <TableCell>Status</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {attendanceStats.attendedUsers.data.map((user, index) => (
                                                                <TableRow 
                                                                    key={index}
                                                                    style={{ 
                                                                        backgroundColor: user.isCurrentlyActive ? '#e3f2fd' : 'transparent'
                                                                    }}
                                                                >
                                                                    <TableCell>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                            <Avatar src={user.profile_photo} style={{ width: '30px', height: '30px' }} />
                                                                            {user.username || 'N/A'}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell>{user.email}</TableCell>
                                                                    <TableCell>
                                                                        {new Date(user.lastAttendedAt).toLocaleString()}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {user.isCurrentlyActive ? (
                                                                            <Chip 
                                                                                label="Currently Active" 
                                                                                size="small"
                                                                                style={{ backgroundColor: '#4CAF50', color: 'white' }}
                                                                            />
                                                                        ) : (
                                                                            <Chip 
                                                                                label="Attended" 
                                                                                size="small"
                                                                                style={{ backgroundColor: '#9E9E9E', color: 'white' }}
                                                                            />
                                                                        )}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Paper>
                                                {attendanceStats.attendedUsers.total_pages > 1 && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                                                        <Pagination 
                                                            count={attendanceStats.attendedUsers.total_pages} 
                                                            page={attendanceStats.attendedUsers.current_page || attendedUsersPage}
                                                            onChange={handleAttendedUsersPageChange}
                                                            color="primary"
                                                        />
                                                    </div>
                                                )}
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>
                        )}
                    </BackPaper>
                </>}

        </>
    )
}

export default EventDetail